type BooleanRendererProps = {
    value: boolean;
    customLabel?: {
        'true': string,
        'false': string,
    }
};
export const BooleanRenderer = ({
                                    value,
                                    customLabel = {
                                        'true': 'Yes',
                                        'false': 'No',
                                    }
                                }: BooleanRendererProps
) => <>{value ? customLabel.true : customLabel.false}</>;
